module.exports = __webpack_public_path__ + "img/4words_title.6b8c38a2.png";